module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/hero-e83896f944253aba5049b9a5a08a261a.jpg";